/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Prop, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {IssueStepInterface} from '@/store/modules/content/types';

/**
 * Solve Issue Info component.
 *
 */
@Component({
    name: 'c-solve-issue-info',
})
export default class SolveIssueInfo extends Vue {

    @Getter('getSteps', {namespace: 'contentStateModule'})
    public getSteps!: () => IssueStepInterface[];

    @Action('fetchSteps', {namespace: 'contentStateModule'})
    private fetchSteps!: () => void;

    /**
     * Mounted lifecycle hook
     *
     * @return {Promise<void>}
     */
    public async mounted(): Promise<void> {
        this.fetchSteps();
    }
}
